// The two-step verification card, as the states it moves through.
// docs/plan/account.md §5.3.
//
// Off, then enrolling with a secret on screen, then on — and a code that
// did not match keeps the secret up rather than discarding it, because
// the pool's association is still valid for the next attempt and making
// the reader scan again would be making them pay for a typo.

export type Enrolment =
  | { step: 'off' }
  | { step: 'enrolling'; secret: string; otpauthUri: string; error?: string }
  | { step: 'on' }

export type EnrolmentEvent =
  /** What the pool says the account has. */
  | { type: 'described'; mfa: 'off' | 'totp' }
  /** *Turn on*: the pool associated a secret. */
  | { type: 'begun'; secret: string; otpauthUri: string }
  /** *Confirm* was refused; `message` is the sentence to show under the code. */
  | { type: 'refused'; message: string }
  | { type: 'confirmed' }
  /** *Cancel*: the association is discarded, and an unverified one is inert. */
  | { type: 'cancelled' }
  | { type: 'disabled' }

export function enrolment(state: Enrolment, event: EnrolmentEvent): Enrolment {
  switch (event.type) {
    case 'described':
      // A re-read while the reader is half-way through enrolling must not
      // take the code off their screen: the pool says "off" until they
      // confirm, which is true and is not what they are looking at.
      if (state.step === 'enrolling') return state
      return { step: event.mfa === 'totp' ? 'on' : 'off' }
    case 'begun':
      return { step: 'enrolling', secret: event.secret, otpauthUri: event.otpauthUri }
    case 'refused':
      return state.step === 'enrolling' ? { ...state, error: event.message } : state
    case 'confirmed':
      return { step: 'on' }
    case 'cancelled':
    case 'disabled':
      return { step: 'off' }
  }
}
